import React from 'react';
import { Props } from './renderContent';
import ImageBox from '../ImageBox/ImageBox';

const Image = ({ children, options }: Props) => React.createElement(ImageBox, { children, options });

export default Image;